<template>
  <VideoSection />
  <PricesList />
  <AlertContact />
  <SectionCertified :btn-text="$t('button-get-certified')" />
</template>

<script>
import VideoSection from './components/VideoSection.vue'
import PricesList from './components/PricesList.vue'
import AlertContact from '../Contact/components/AlertContact.vue'
import SectionCertified from '../../components/SectionCertified.vue'

export default {
  components: {
    VideoSection,
    PricesList,
    AlertContact,
    SectionCertified
  }
}
</script>
